/* models/textures/image_url_texture.js */ function _(require, module, exports) {
    const texture_1 = require(305) /* ./texture */;
    const p = require(18) /* ../../core/properties */;
    const image_1 = require(216) /* ../../core/util/image */;
    class ImageURLTexture extends texture_1.Texture {
        constructor(attrs) {
            super(attrs);
        }
        static init_ImageURLTexture() {
            this.define({
                url: [p.String],
            });
        }
        initialize() {
            super.initialize();
            this._loader = new image_1.ImageLoader(this.url);
        }
        get_pattern(_color, _scale, _weight) {
            return (ctx) => {
                if (!this._loader.finished) {
                    return null;
                }
                return ctx.createPattern(this._loader.image, this.repetition);
            };
        }
        onload(defer_func) {
            this._loader.promise.then(() => defer_func());
        }
    }
    exports.ImageURLTexture = ImageURLTexture;
    ImageURLTexture.__name__ = "ImageURLTexture";
    ImageURLTexture.init_ImageURLTexture();
}
